<div class="dashboard-search-filters">
    <!-- button for open filters -->
    <app-helpers-search-filters-menu
      [filters]="filtersMenu"
      (chooseFilter)="onSelectFilter($event)"
   ></app-helpers-search-filters-menu>

   <!-- dashboard filters -->
   <app-helpers-search-filters-labels-main
      *ngIf="selectedFilter == 'label'"
      [available]="availableLabels"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-labels-main>
    <app-helpers-search-filters-users-main
      *ngIf="selectedFilter == 'user_assigned'"
      [available]="availableAsignees"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-users-main>
    <app-helpers-search-filters-users-main
      *ngIf="selectedFilter ==  'user_owner'"
      [available]="availableOwners"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-users-main>
    <app-helpers-search-filters-worlflow-status-main
      *ngIf="selectedFilter ==  'status'"
      [available]="availableStatus"
      [applied]="appliedFilters"
      (apply)="onApplyFilter($event)"
    ></app-helpers-search-filters-worlflow-status-main>
    
    <!-- maybe more filters here -->
</div>
